<template>
  <div class="d-flex flex-column flex-md-row mx-n2 pa-2">
    <div class="pa-2">
      <custom-input-text
          @keyup.enter="onChangeFilter"
          v-model="filter.name"
          hide-details
          clearable
          label="Название или бренд"
      ></custom-input-text>
    </div>
    <div class="pa-2">
      <custom-input-text
          clearable
          @keyup.enter="onChangeFilter"
          v-model="filter.inn"
          hide-details
          label="ИНН"
      ></custom-input-text>
    </div>
    <div class="pa-2">
      <v-btn @click="clear" color="error"
             :width="$vuetify.breakpoint.smAndDown ? '100%' : null" style="min-width: auto">
        <v-icon>fas fa-times</v-icon>
      </v-btn>
    </div>
    <div class="pa-2">
      <v-btn :width="$vuetify.breakpoint.smAndDown ? '100%' : null" @click="onChangeFilter"
             color="primary"
             style="min-width: auto">
        <v-icon>fas fa-search</v-icon>
      </v-btn>
    </div>
  </div>
</template>


<script>
import FilterTemplate from "@/components/ui/template-filter/TemplateFIlter";

const DEFAULT_FILTER_DATA = {
  name: null,
  inn: null
}
export default {
  name: 'MkoIndexFilter',
  components: {FilterTemplate},
  props: {
    filter: {
      type: Object,
      default() {
        return {
          ...DEFAULT_FILTER_DATA
        }
      }
    }
  },
  methods: {
    clear() {
      this.$emit('update:filter', {...DEFAULT_FILTER_DATA})
      this.onChangeFilter()
    },
    onChangeFilter() {
      this.$emit('change')
    }
  }
}
</script>